Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.DataFormatter
  constructor: (nameTranslator, valueTranslator=new CustomerVisualMode.NullValueTranslator) ->
    @nameTranslator = nameTranslator
    @valueTranslator = valueTranslator

  format: (widget, data) ->
    translatedData = @_translatedData(widget, data)
    formattedData = widget.sortData(translatedData)
    formattedData = formattedData.slice(0, 10) if widget.get('show_top_ten')
    formattedData.map((item) -> {x: item.name, y: item.value, id: item.id})

  _translatedData: (widget, data) ->
    translatedData = @_translateNames data.data
    translatedData = translatedData.concat(@_missingValuesItem(data)) if widget.shouldAddMissing(data)
    translatedData

  _translateNames: (data) ->
    data.map((item) => {id: item.name, value: @valueTranslator.translate(item), name: @nameTranslator.name(item)})

  _missingValuesItem: (data) ->
    {
      name: I18n.t 'customer_visual_mode.charts.single_dimension.tickets_without_values'
      value: data.missing
      id: 'missing'
    }
